module.exports = __webpack_public_path__ + "static/media/303KnobLabel--resonance.e8ab8561.svg";